<ng-container>
  <div
    class="w-full py-3 flex align-items-center justify-content-between border-bottom-1 border-bottom-solid mb-3"
    [style]="{ 'border-color': 'var(--primary-gray)' }"
  >
    <h2 class="text-xl font-semibold" data-clarity-unmask="true">Zakup abonamentu</h2>
    <p-button
      icon="pi pi-times"
      [rounded]="true"
      [text]="true"
      size="small"
      (onClick)="closeDialog()"
      data-clarity-unmask="true"
    ></p-button>
  </div>
</ng-container>
<div class="flex flex-column justify-content-between mt-3 gap-3">
  <section>
    <section class="w-full flex flex-column md:flex-row row-gap-2 p-2 md:p-3 border-bottom-1 border-bluegray-300">
      <p
        class="flex-none flex align-items-center w-12rem text-gray-500 font-normal text-sm"
      >
        Wybierz abonament
      </p>
      <div class="flex-grow-1 flex flex-wrap align-items-center gap-2">
        <app-subscription-tag
          *ngFor="let subscription of availableSubscriptions"
          [bgColor]="subscription.bgColor"
          [fgColor]="subscription.fgColor"
          [planName]="subscription.planName"
          [selectable]="true"
          (onSelectEvent)="addSubscriptionToSelectedList(subscription)"
        ></app-subscription-tag>
      </div>
    </section>

    <section>
      <p-table [value]="selectedSubscriptions">
        <ng-template pTemplate="header">
          <tr class="transparent">
            <th class="md:w-12rem text-gray-500 font-normal text-sm">
              Nazwa
            </th>
            <th class="md:w-12rem text-gray-500 font-normal text-sm">
              Ilość
            </th>
            <th class="text-gray-500 font-normal text-sm">Kwota netto</th>
            <th class="text-gray-500 font-normal text-sm">Akcje</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-subscription let-rowIndex="rowIndex">
          <tr>
            <td>
              <div
                class="selected-plan py-1 px-2 text-sm border-round-sm gap-2 cursor-pointer md:w-max"
                [style.backgroundColor]="subscription.subscriptionPlan.bgColor"
                [style.color]="subscription.subscriptionPlan.fgColor"
              >
                {{ subscription.subscriptionPlan.planName }}
              </div>
            </td>
            <td class="py-2">
              <p-inputNumber
                class="quantity-input-number"
                [(ngModel)]="selectedSubscriptions[rowIndex].quantity"
                [showButtons]="true"
                buttonLayout="horizontal"
                inputId="horizontal"
                spinnerMode="horizontal"
                incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi pi-minus"
                [min]="0"
                (ngModelChange)="saveSelectedSubscriptionsToLocalStorage()"
              />
            </td>
            <td>
              {{
                getNetValue(
                  subscription.quantity,
                  subscription.subscriptionPlan.value,
                  subscription.subscriptionPlan.vatPercentage
                )
              }}&nbsp;zł
            </td>
            <td>
              <p-button
                icon="pi pi-trash"
                [rounded]="true"
                [text]="true"
                (onClick)="
                  removeSubscriptionFromSelectedList(
                    subscription.subscriptionPlan
                  )
                "
                data-clarity-unmask="true"
              ></p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr *ngIf="selectedSubscriptions.length > 0">
            <td></td>
            <td>
              <div
                class="flex flex-column gap-3 text-gray-500 font-normal text-sm"
              >
                <p class="text-sm">Kwota netto</p>
                <p class="text-sm">Podatek VAT (23%)</p>
                <p class="text-sm font-semibold">ŁĄCZNY KOSZT</p>
              </div>
            </td>
            <td>
              <div class="flex flex-column gap-3 font-normal text-sm">
                <p class="text-sm">
                  {{ getTotalValue().totalNetValue }}&nbsp;zł
                </p>
                <p class="text-sm">{{ getTotalValue().totalVat }}&nbsp;zł</p>
                <p class="text-sm font-semibold">
                  {{ getTotalValue().totalGrossValue }}&nbsp;zł
                </p>
              </div>
            </td>
            <td></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="12" class="text-gray-500 font-normal text-sm">
              Nie wybrano żadnego abonamentu
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>
  </section>
  <section class="flex gap-3 justify-content-end">
    <p-button
      label="Anuluj"
      (onClick)="closeDialog()"
      [outlined]="true"
      [disabled]="loading"
      data-clarity-unmask="true"
    >
    </p-button>
    <p-button
      label="Zamów"
      icon="pi pi-save"
      (onClick)="buySubscriptions()"
      [loading]="loading"
      data-clarity-unmask="true"
    >
    </p-button>
  </section>
</div>
